const locale = {
    placeholder: 'Sila pilih masa',
    rangePlaceholder: ['Masa mula', 'Masa tamat'],
};
export default locale;
